<app-dialog
  [headerGlyph]="[$any('workspace'), $any('yaml')]"
  [headerText]="title"
  cancelText="Close"
  [showTopCancelButton]="false"
  [showCancelButton]="true"
  [showSaveButton]="false"
  [body]="body"
  (cabcel)="onCancel()"
>
  <ng-template #body>
    @if (successful.length > 0) {
      <div class="container">
        <label fd-form-label class=""
          >At least one of the resources in your YAML file was not created
          successfully.</label
        >
        <label fd-form-label class="vertical-space"
          >Successfully created resources:</label
        >
        <ul class="resource-list">
          @for (resource of successful; track resource) {
            <li class="resource-item">
              <div class="resource-content">
                <span class="resource-font"
                  >{{ resource.name }} | {{ resource.type }} ({{
                    resource.group
                  }}/{{ resource.version }})</span
                >
                <span
                  fd-object-status
                  status="positive"
                  glyph="sys-enter-2"
                  title="Successful"
                  class="report-space"
                ></span>
              </div>
            </li>
          }
        </ul>
      </div>
    }

    @if (failed.length > 0) {
      <div class="container">
        @if (successful.length > 0) {
          <label fd-form-label>Failed resources:</label>
        }
        @if (successful.length === 0) {
          <label fd-form-label
            >We couldn't create any of the resources from your YAML file.</label
          >
        }
        <ul class="resource-list">
          @for (resource of failed; track resource; let i = $index) {
            <li class="resource-item">
              <div class="resource-content">
                <span class="resource-font"
                  >{{ resource.name }} | {{ resource.type }} ({{
                    resource.group
                  }}/{{ resource.version }})</span
                >
                <div>
                  <span
                    fd-object-status
                    status="negative"
                    glyph="error"
                    title="Failed"
                    class="report-space"
                  ></span>
                  <app-help-popover
                    class="report-space"
                    headerTitle="Error Details"
                    linkText="View Details"
                    [body]="tmp"
                    width="30rem"
                    [linkEmphasized]="false"
                    placement="top"
                  ></app-help-popover>
                  <ng-template #tmp>
                    <div
                      style="
                        display: grid;
                        grid-template-columns: auto 1fr;
                        margin-bottom: 0.5rem;
                      "
                    >
                      <label fd-form-label>Resource:</label>
                      <span
                        >{{ resource.name }} | {{ resource.type }} ({{
                          resource.group
                        }}/{{ resource.version }})</span
                      >
                    </div>
                    @if (resource.errorMessage?.startsWith("Reason:")) {
                      <div
                        style="display: grid; grid-template-columns: auto 1fr"
                      >
                        <label fd-form-label>Reason:</label>
                        <span>{{ resource.errorMessage.substring(7) }}</span>
                      </div>
                    }
                    @if (!resource.errorMessage?.startsWith("Reason:")) {
                      <div
                        style="display: grid; grid-template-columns: auto 1fr"
                      >
                        <label fd-form-label>Reason:</label>
                        <span>{{ resource.errorMessage }}</span>
                      </div>
                    }
                  </ng-template>
                  @if (expandedErrors[i]) {
                    <div>
                      {{ resource.errorMessage }}
                    </div>
                  }
                </div>
              </div>
            </li>
          }
        </ul>
        @if (successful.length === 0) {
          <label fd-form-label
            >Please review and address the issues before trying again.</label
          >
        }
        @if (successful.length > 0) {
          <label fd-form-label
            >Please review the failed resources and address the issues before
            trying again.</label
          >
        }
      </div>
    }
  </ng-template>
</app-dialog>
